var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"col":"12","md":"3"}},[_c('b-card',[_c('h6',[_vm._v("Choose containers")])])],1),_c('b-col',{attrs:{"col":"12","md":"9"}},[_c('b-card',[_vm._v(" dsfsdf ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }